import React from 'react';
import CircleProgress from './CircleProgress';

export default function RiskComplianceCard({
  percentage = 78,
  title = 'Title',
  testo = 'Testo'
}) {
  return (
    <div className="flex flex-col h-full items-center bg-white p-6 rounded-lg border min-h-[250px]">
      <div className="flex flex-col gap-7 w-full">
        <div className="text-2xl font-bold text-gray-900">
          <p>{title}</p>
        </div>

        <div className="flex flex-row items-start justify-between w-full">
          {/* Testo */}
          <div className="flex-1 pr-6">
            <p className="text-gray-700 leading-relaxed">{testo}</p>
          </div>

          {/* Progress */}
          <div className=" flex items-center justify-center flex-shrink-0">
            <CircleProgress percentage={percentage} size={120} strokeWidth={12} />
          </div>
        </div>
      </div>
    </div>
  );
}
